<script>
import CrispHelper from '@d-shared/helpers/crisp/crisp';
import ADuiTabOptions from '@dui/components/a-dui-tab-options/a-dui-tab-options.vue';
import TAB_OPTION_TEXT_IMG from '@dui-assets/tab-option-text.svg';
import TAB_OPTION_VIDEO_IMG from '@dui-assets/tab-option-video.svg';

const REVIEW_TYPE_OPTIONS = [
  {
    image: TAB_OPTION_TEXT_IMG,
    title: 'Written review',
    topOverride: '38px',
    value: 'written',
  },
  {
    image: TAB_OPTION_VIDEO_IMG,
    title: 'Video review',
    topOverride: null,
    value: 'video',
  },
];

const DISABLED_TAB_TEXTS = {
  title: 'Unlock {{ type }} reviews',
  description: 'To post reviews in this format, please submit a {{ type }} review example to the Discovery team for consideration.',
};

export default {
  extends: ADuiTabOptions,
  props: {
    disabledTab: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    vm: {
      options: REVIEW_TYPE_OPTIONS,
    },
  }),
  mounted() {
    if (!this.disabledTab) return;

    const updatedOptions = REVIEW_TYPE_OPTIONS.slice();

    const optionToUpdateId = updatedOptions.findIndex((option) => option.value === this.disabledTab);

    updatedOptions[optionToUpdateId].title = DISABLED_TAB_TEXTS.title.replace('{{ type }}', this.disabledTab);
    updatedOptions[optionToUpdateId].description = DISABLED_TAB_TEXTS.description.replace('{{ type }}', this.disabledTab);
    updatedOptions[optionToUpdateId].disabled = true;
    updatedOptions[optionToUpdateId].extraClickCallback = this.clickDisabledTab;
    this.$set(this.vm, 'options', updatedOptions);
  },
  methods: {
    clickDisabledTab() {
      CrispHelper.openChat();
    },
  },
};
</script>
